// Общий маппинг категорий курсов (код → отображаемое имя на русском)

export const COURSE_CATEGORY_LABELS_RU = {
	// Новые категории из конструктора курсов
	programming: 'Программирование',
	design: 'Дизайн',
	marketing: 'Маркетинг',
	business: 'Бизнес',
	languages: 'Иностранные языки',
	personal: 'Личностный рост',
	other: 'Другое',

	// Старые/альтернативные коды, которые могут приходить из БД
	tech: 'Техническая подготовка',
	sales: 'Продажи',
	management: 'Управление и менеджмент',
	development: 'Разработка',
}

const COURSE_CATEGORY_ALIASES = {
	// Синонимы и разные форматы кодов
	it: 'tech',
	technical: 'tech',
	technologies: 'tech',
	technology: 'tech',
	tehnical: 'tech',
	tehnology: 'tech',
	'техническая_подготовка': 'tech',
	'техническая': 'tech',
	'программирование': 'programming',
	'иностранные_языки': 'languages',
	'личностный_рост': 'personal',
	'управление': 'management',
	'менеджмент': 'management',
	'разработка': 'development',
}

// Список опций для селектов (value/label)
// Можно использовать в формах создания/редактирования курсов
export const COURSE_CATEGORY_OPTIONS_RU = Object.entries(
	COURSE_CATEGORY_LABELS_RU
).map(([value, label]) => ({ value, label }))

export function normalizeCourseCategoryKey(category) {
	if (!category) return ''

	const raw = String(category).trim()
	if (!raw) return ''

	const normalized = raw.toLowerCase().replace(/[\s-]+/g, '_')
	return COURSE_CATEGORY_ALIASES[normalized] || normalized
}

/**
 * Возвращает человеко-читаемое русское название категории по её коду.
 * Если код не известен, возвращает исходное значение без изменений.
 */
export function getCourseCategoryLabel(category) {
	if (!category) return 'Без категории'

	const normalizedKey = normalizeCourseCategoryKey(category)
	if (COURSE_CATEGORY_LABELS_RU[normalizedKey]) {
		return COURSE_CATEGORY_LABELS_RU[normalizedKey]
	}

	const raw = String(category).trim()
	return raw || 'Без категории'
}
